/**
 * Formats a firmware major/minor/revision triplet as `vX.Y.Z` (Sphero drive unit / accessory convention).
 */
export function formatFirmwareVersion(major: number, minor: number, revision: number): string {
  return `v${major}.${minor}.${revision}`;
}

/**
 * Like {@link formatFirmwareVersion}, but returns `undefined` when any component is missing
 * (e.g. SDK fields not populated yet).
 */
export function formatFirmwareVersionOrUndefined(
  major: number | null | undefined,
  minor: number | null | undefined,
  revision: number | null | undefined
): string | undefined {
  if (major == null || minor == null || revision == null) return undefined;
  return formatFirmwareVersion(major, minor, revision);
}
